import { render, staticRenderFns } from "./chooseDevelopModal.vue?vue&type=template&id=13d178d9&scoped=true"
import script from "./chooseDevelopModal.vue?vue&type=script&lang=js"
export * from "./chooseDevelopModal.vue?vue&type=script&lang=js"
import style0 from "./chooseDevelopModal.vue?vue&type=style&index=0&id=13d178d9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d178d9",
  null
  
)

export default component.exports